import React, { useState } from 'react';
import { db } from '../../../firebaseConfig'; // assuming you have a firebase.js file with the db instance
import { addDoc, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import { Box, Button, TextField, Typography, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

const YourProduct = () => {
  const userData = JSON.parse(localStorage.getItem('user') || null);
  const { userId } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [productData, setProductData] = useState({
    img: '',
    price: '',
    description: '',
    seller: userData?.name || '',
    sellerRating: userData?.sellerRating || '',
    badge: userData?.badge || '',
    phone: userData?.phone || '',
    upiNum:userData?.upiNum || '',
  });

  const handleOpenDialog = () => {
    setIsOpen(true);
  };

  const handleCloseDialog = () => {
    setIsOpen(false);
  };

  const handleSubmit = async () => {
    try {
      const storeRef = doc(db, 'store', userId);
      await setDoc(storeRef, productData);

      const profileProductRef = doc(db, 'profileProduct', userId);
      const profileProductDoc = await getDoc(profileProductRef);

      if (profileProductDoc.exists()) {
        const cartData = profileProductDoc.data();
        cartData.product.push(productData);
        await updateDoc(profileProductRef, { product: cartData.product });
      } else {
        const newCartData = { product: [productData] };
        await addDoc(profileProductRef, newCartData);
      }

      console.log('Product data saved successfully!');
    } catch (error) {
      console.error('Error saving product data:', error);
    }
    handleCloseDialog();
  };

  return (
    <Box display="flex" justifyContent="center" mt={4}>
      <Button variant="contained" color="primary" onClick={handleOpenDialog}>
        Post Your Product
      </Button>

      <Dialog open={isOpen} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h3" align="center"> 
            Post Your Product
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ mt: 2 }}>
            <TextField
              label="Product Image URL"
              fullWidth
              value={productData.img}
              onChange={(e) => setProductData({ ...productData, img: e.target.value })}
              margin="normal"
            />
            <TextField
              label="Price"
              type="number"
              fullWidth
              value={productData.price}
              onChange={(e) => setProductData({ ...productData, price: e.target.value })}
              margin="normal"
            />
            <TextField
              label="Product Description"
              fullWidth
              multiline
              rows={4}
              value={productData.description}
              onChange={(e) => setProductData({ ...productData, description: e.target.value })}
              margin="normal"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default YourProduct;
